import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  position: relative;
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  color: rgb(115, 117, 119);
  > :first-child {
    font-size: 1.4rem;
    margin: 0;
    padding: 0;
    margin-block-start: 0;
    margin-block-end: 0;
    line-height: 2.4;
    color: ${(props: any) => props.theme.primary};
  }
  font-size: 1.4rem;
  line-height: 2.2;
`

interface IProps {
  title: string,
  description: string
}

const PageTitle = (props: IProps) => <Wrapper>
    <h2>{props.title}</h2>
    <div>{props.description}</div>
  </Wrapper>

export default PageTitle
